import {
  CREATE_GROUP_URL,
  DELETE_GROUP,
  GROUP_DROPDOWN,
  GROUP_INFO,
  LIST_GROUP,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createGroup = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_GROUP_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listGroup = (props) => (onResponse) => {
  try {
    let BASE_URL = LIST_GROUP + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props.role) {
      BASE_URL += "role=" + props.role + "&";
    }
    if (props.user_id) {
      BASE_URL += "user_id=" + props.user_id + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        console.log(response);
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
export const getGroupInfo = (props) => (onResponse) => {
  try {
    axiosInstance
      .get(GROUP_INFO + "?group=" + props.id)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
export const deleteGroupDetails = (id) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_GROUP, { data: { group: id } })

      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listGroupDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = GROUP_DROPDOWN + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
